import { Row } from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { type ScopeData } from '../../../state/server';
import { useConsentClientContext } from '../State/consentClientState';
import { Group } from './Group';

export function Groups(props: { data: Record<string, ScopeData[]> }) {
  const { data } = props;
  const [consentClient] = useConsentClientContext();
  const { isMobile } = useScreenSize();
  const groupKeys = Object.keys(data);

  return (
    <Row colGap="60" rowGap={isMobile ? '20' : '0'} wrap="wrap">
      {groupKeys.map((key) => {
        const group = data[key];
        return (
          <Group
            key={key}
            group={group}
            title={consentClient.localization?.[group[0].group ?? ''] ?? ''}
          />
        );
      })}
    </Row>
  );
}
